import React from 'react';
import logo from '../assets/logo.svg'
import logo2 from '../assets/white_logo.png'

const AuthWrapper = () => {
  return (
    <div className='auth-wrapper d-flex justify-content-center flex-column align-items-center'>
        <img src={logo} alt='white_logo' width={280} height={280} className='mb-5'/>
        <img src={logo2} alt='white_logo' width={307} height={48} className='mb-5'/>
        <p><span>Balanceko</span> is a cutting-edge software solution that meticulously tracks and organizes all financial transactions for business enterprises.</p>
    </div>
  )
}

export default AuthWrapper